import React from 'react'
import AdminLayout from '../../../layouts/AdminLayout'

const Community = () => {
  return (
    <div>
         <AdminLayout>
             <div className="ct_px_40 my-5">
         <div className="container-fluid">
            <div className="row gx-5">
               <div className="col-xxl-9 col-xl-8 col-lg-8 mb-4">
                 <div class="ct_mb_30">
            <h4 class="mb-0 ct_fs_20  mb-2">Connect Hub</h4>
            <p class="ct_grey_text mb-0 ct_fs_14">
              Fit insights into platform activity, user growth, project status and service performance. 
            </p>
          </div>


             <div class="row">
            <div class="col-xl-4 col-lg-6 ct_mb_10">
              <div class="ct_outline_bg h-100 d-grid">
                <div>
                    <div class="d-flex align-items-start justify-content-between gap-2">
                  <div>
                    <p class="ct_fs_14 ct_sky_blue_text ct_mb_16">
                      Coach Talks
                    </p>
                    <h4 class="ct_fs_24 mb-0">5</h4>
                  </div>
                  <img src="../assets/img/dash_icon_1.png" alt="" />
                </div>
                <ul class="d-flex align-items-center gap-2 ct_mt_16 pb-3">
                  <li class="ct_fs_12 ct_yellow_text ct_white_nowrap">
                    <svg
                      width="23"
                      height="24"
                      viewBox="0 0 23 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1696_32114)">
                        <path
                          d="M7.03156 16.2038L15.3574 8.03125"
                          stroke="#FFB703"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                          stroke="#FFB703"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1696_32114">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(11.418 0.6875) rotate(45.5323)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    24%
                  </li>
                  <li class="ct_text_op_2">|</li>
                  <li class="ct_grey_text ct_fs_12">
                   Platform news, upcoming opportunities, feature updates.
                  </li>
                </ul>
                </div>
                <div class="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light mt-auto ">
                  <a href="#" class="ct_skyblue_link ct_fs_14">
                   View
                  </a>
                  <a href="#">
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.834 6.3125L1.16732 6.3125M12.834 6.3125L7.83398 11.3125M12.834 6.3125L7.83398 1.3125"
                        stroke="#8ECAE6"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-6 ct_mb_10">
              <div class="ct_outline_bg h-100 d-grid">
               <div>
                 <div class="d-flex align-items-start justify-content-between gap-2">
                  <div>
                    <p class="ct_fs_14 ct_orange_text ct_mb_16">
                    Cross Group 
                    </p>
                    <h4 class="ct_fs_24 mb-0">2</h4>
                  </div>
                  <img src="../assets/img/dash_icon_2.png" alt="" />
                </div>
                <ul class="d-flex align-items-center gap-2 ct_mt_16 pb-3">
                  <li class="ct_fs_12 ct_sky_blue_text ct_white_nowrap">
                    38%
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1696_32145)">
                        <path
                          d="M5.73231 8.00261L15.8359 13.8359"
                          stroke="#8ECAE6"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9.74891 15.7105L16.1237 14.0024L14.4156 7.6276"
                          stroke="#8ECAE6"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1696_32145">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(21.8555 8.07031) rotate(120)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </li>
                  <li class="ct_text_op_2">|</li>
                  <li class="ct_grey_text ct_fs_12">Spotlight on active coaches, top events, success stories. </li>
                </ul>
               </div>
                <div class="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light mt-auto">
                  <a href="#" class="ct_orange_link_underline ct_fs_14">
                    View 
                  </a>
                  <a href="#">
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.834 6.92969L1.16732 6.92969M12.834 6.92969L7.83398 11.9297M12.834 6.92969L7.83398 1.92969"
                        stroke="#FB8500"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-6 ct_mb_10">
              <div class="ct_outline_bg h-100 d-grid">
                <div>
                     <div class="d-flex align-items-start justify-content-between gap-2">
                  <div>
                    <p class="ct_fs_14 ct_yellow_text ct_mb_16">
                 Learning & Upskilling
                    </p>
                    <h4 class="ct_fs_24 mb-0">64h51m </h4>
                  </div>
                  <img src="../assets/img/dash_icon_3.png" alt="" />
                </div>
                <ul class="d-flex align-items-center gap-2 ct_mt_16 pb-3">
                  <li class="ct_fs_12 ct_orange_text ct_white_nowrap">
                    <svg
                      width="23"
                      height="24"
                      viewBox="0 0 23 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1696_32114)">
                        <path
                          d="M7.03156 16.2038L15.3574 8.03125"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1696_32114">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(11.418 0.6875) rotate(45.5323)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    24%
                  </li>
                  <li class="ct_text_op_2">|</li>
                  <li class="ct_grey_text ct_fs_12">
                   7 more days for Nuvio review
                  </li>
                </ul>
                </div>
                <div class="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light mt-auto">
                  <a href="#" class="ct_yellow_link ct_fs_14">
                    View
                  </a>
                  <a href="#">
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.834 6.92969L1.16732 6.92969M12.834 6.92969L7.83398 11.9297M12.834 6.92969L7.83398 1.92969"
                        stroke="#023047"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
         
          </div>

          <div className='row'>
                          
                <div class="col-xl-4 mb-4 col-lg-4">
                  <div class="ct_outline_bg h-100">
                    <h4 class="ct_fs_20  ct_darksky_blue_text">Sessions </h4>
                    <div id="ct_event_chart"></div>
                    <div class="session-stats">
                      <div class="d-flex align-items-start">
                        <span
                          class="booked-dot"
                          style={{ backgroundColor: "#8ECAE6" }}
                        ></span>
                        <div>
                          <h6 class="ct_fs_24 mb-1">62</h6>
                          <p class="mb-0 ct_grey_text">Booked</p>
                        </div>
                      </div>
                      <div class="d-flex align-items-start">
                        <span
                          class="completed-dot"
                          style={{
                            backgroundColor:
                              "hsl(199.09deg 63.77% 72.94% / 21%)",
                          }}
                        ></span>
                        <div>
                          <h6 class="ct_fs_24 mb-1">188</h6>
                          <p class="mb-0 ct_grey_text">Completed</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                  <div class="col-xl-4 mb-4 col-lg-4">
                  <div class="ct_outline_bg h-100">
                    <h4 class="ct_fs_20  ct_sky_blue_text">Events </h4>
                    <div id="ct_event_chart"></div>
                    <div class="session-stats">
                      <div class="d-flex align-items-start">
                        <span
                          class="booked-dot"
                          style={{ backgroundColor: "#8ECAE6" }}
                        ></span>
                        <div>
                          <h6 class="ct_fs_24 mb-1">2</h6>
                          <p class="mb-0 ct_grey_text">Active</p>
                        </div>
                      </div>
                      <div class="d-flex align-items-start">
                        <span
                          class="completed-dot"
                          style={{
                            backgroundColor:
                              "hsl(199.09deg 63.77% 72.94% / 21%)",
                          }}
                        ></span>
                        <div>
                          <h6 class="ct_fs_24 mb-1">5</h6>
                          <p class="mb-0 ct_grey_text">Inactive</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                                  <div class="col-xl-4 mb-4 col-lg-4">
                  <div class="ct_outline_bg h-100">
                    <h4 class="ct_fs_20  ct_sky_blue_text">Events </h4>
                    <div id="ct_event_chart"></div>
                    <div class="session-stats">
                      <div class="d-flex align-items-start">
                        <span
                          class="booked-dot"
                          style={{ backgroundColor: "#8ECAE6" }}
                        ></span>
                        <div>
                          <h6 class="ct_fs_24 mb-1">2</h6>
                          <p class="mb-0 ct_grey_text">Active</p>
                        </div>
                      </div>
                      <div class="d-flex align-items-start">
                        <span
                          class="completed-dot"
                          style={{
                            backgroundColor:
                              "hsl(199.09deg 63.77% 72.94% / 21%)",
                          }}
                        ></span>
                        <div>
                          <h6 class="ct_fs_24 mb-1">5</h6>
                          <p class="mb-0 ct_grey_text">Inactive</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

          </div>


          <div>
             <div
            class="d-flex align-items-start gap-3 justify-content-between mb-3 ct_flex_col_1199 pb-3 pb-xl-0"
            style={{borderBottom: "1px solid #cccccc"}}
          >
            <ul class="ct_table_filter border-0 ct_table_filter_orange">
              <li class="active">All (50) </li>
              <li>Cross Group (5)</li>
              <li> Coach Talk (1)</li>
              <li>Learning (3)</li>
              <li>Draft (1)  </li>
            </ul>
            <div class="position-relative ct_flex_shrink_0 d-flex align-items-center gap-2 ct_flex_col_575 ct_w_100_575">
            <div class="position-relative ct_w_100_575"><input class="form-control ct_input ct_h_35 ps-5 ct_border_radius_20" placeholder="Search by Name" type="text"/><i class="fa-solid fa-search ct_input_icon_left"></i></div>
            <button class="ct_yellow_btn ct_orange_btn ct_h_35 ct_w_100_575">Create  <svg className='ms-1' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.00065 1.33594C4.31786 1.33594 1.33398 4.31981 1.33398 8.0026C1.33398 11.6854 4.31786 14.6693 8.00065 14.6693C11.6834 14.6693 14.6673 11.6854 14.6673 8.0026C14.6673 4.31981 11.6834 1.33594 8.00065 1.33594ZM11.8716 8.75529C11.8716 8.93271 11.7265 9.07787 11.549 9.07787H9.07592V11.551C9.07592 11.7284 8.93076 11.8736 8.75334 11.8736H7.24796C7.07054 11.8736 6.92538 11.7284 6.92538 11.551V9.07787H4.45226C4.27484 9.07787 4.12968 8.93271 4.12968 8.75529V7.24992C4.12968 7.0725 4.27484 6.92734 4.45226 6.92734H6.92538V4.45422C6.92538 4.2768 7.07054 4.13164 7.24796 4.13164H8.75334C8.93076 4.13164 9.07592 4.2768 9.07592 4.45422V6.92734H11.549C11.7265 6.92734 11.8716 7.0725 11.8716 7.24992V8.75529Z" fill="white"/>
</svg>
</button>
            </div>
          </div>


             <div className="table-responsive ct_custom_table ct_custom_table2 pt-3 ct_light_orange_table_2">
                  <table class="table">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Type</th>
                  <th>Stage</th>
                  <th>Date</th>
                  <th>Visibility</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <h5 class="ct_fs_16  ct_darkblue_text mb-0 ct_overlay_text">“Designing for Mobile”</h5>
                  </td>
                  <td>Coach Talk</td>
                  <td>
                    <span class="ct_publish_badge">Publish</span>
                  </td>
                  <td>May 2, 2025</td>
                
                  <td>
                    <div class="ct_right_dropdown dropdown">
                      <button
                        id="dropdownMenuButton"
                 
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i class="fa-solid fa-ellipsis"></i>
                      </button>
                      <ul
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            data-bs-target="#ct_profile_modal"
                            data-bs-toggle="modal"
                            >View</a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item ct_darksky_blue_text"
                            data-bs-target="#ct_edit_user_info"
                            data-bs-toggle="modal"
                            href="javascript:void(0)"
                            >Edit Content</a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item ct_yellow_text"
                            href="javascript:void(0)"
                            data-bs-target="#ct_reactivate_account"
                            data-bs-toggle="modal"
                            >Approve
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item ct_darkblue_text"
                            href="javascript:void(0)"
                            data-bs-target="#ct_suspend_account"
                            data-bs-toggle="modal"
                            >Reject
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item text-danger"
                            href="javascript:void(0)"
                            data-bs-target="#ct_remove_user"
                            data-bs-toggle="modal"
                            >Delete
                          </a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
                  <tr>
                  <td>
                    <h5 class="ct_fs_16  ct_darkblue_text mb-0 ct_overlay_text">“Designing for Mobile”</h5>
                  </td>
                  <td>Coach Talk</td>
                  <td>
                    <span class="ct_publish_badge">Publish</span>
                  </td>
                  <td>May 2, 2025</td>
                
                  <td>
                    <div class="ct_right_dropdown dropdown">
                      <button
                        id="dropdownMenuButton"
                 
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i class="fa-solid fa-ellipsis"></i>
                      </button>
                      <ul
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            data-bs-target="#ct_profile_modal"
                            data-bs-toggle="modal"
                            >View</a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item ct_darksky_blue_text"
                            data-bs-target="#ct_edit_user_info"
                            data-bs-toggle="modal"
                            href="javascript:void(0)"
                            >Edit Content</a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item ct_yellow_text"
                            href="javascript:void(0)"
                            data-bs-target="#ct_reactivate_account"
                            data-bs-toggle="modal"
                            >Approve
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item ct_darkblue_text"
                            href="javascript:void(0)"
                            data-bs-target="#ct_suspend_account"
                            data-bs-toggle="modal"
                            >Reject
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item text-danger"
                            href="javascript:void(0)"
                            data-bs-target="#ct_remove_user"
                            data-bs-toggle="modal"
                            >Delete
                          </a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
                  <tr>
                  <td>
                    <h5 class="ct_fs_16  ct_darkblue_text mb-0 ct_overlay_text">“Designing for Mobile”</h5>
                  </td>
                  <td>Coach Talk</td>
                  <td>
                    <span class="ct_publish_badge">Publish</span>
                  </td>
                  <td>May 2, 2025</td>
                
                  <td>
                    <div class="ct_right_dropdown dropdown">
                      <button
                        id="dropdownMenuButton"
                 
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i class="fa-solid fa-ellipsis"></i>
                      </button>
                      <ul
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            data-bs-target="#ct_profile_modal"
                            data-bs-toggle="modal"
                            >View</a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item ct_darksky_blue_text"
                            data-bs-target="#ct_edit_user_info"
                            data-bs-toggle="modal"
                            href="javascript:void(0)"
                            >Edit Content</a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item ct_yellow_text"
                            href="javascript:void(0)"
                            data-bs-target="#ct_reactivate_account"
                            data-bs-toggle="modal"
                            >Approve
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item ct_darkblue_text"
                            href="javascript:void(0)"
                            data-bs-target="#ct_suspend_account"
                            data-bs-toggle="modal"
                            >Reject
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item text-danger"
                            href="javascript:void(0)"
                            data-bs-target="#ct_remove_user"
                            data-bs-toggle="modal"
                            >Delete
                          </a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
                  <tr>
                  <td>
                    <h5 class="ct_fs_16  ct_darkblue_text mb-0 ct_overlay_text">“Designing for Mobile”</h5>
                  </td>
                  <td>Coach Talk</td>
                  <td>
                    <span class="ct_publish_badge">Publish</span>
                  </td>
                  <td>May 2, 2025</td>
                
                  <td>
                    <div class="ct_right_dropdown dropdown">
                      <button
                        id="dropdownMenuButton"
                 
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i class="fa-solid fa-ellipsis"></i>
                      </button>
                      <ul
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            data-bs-target="#ct_profile_modal"
                            data-bs-toggle="modal"
                            >View</a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item ct_darksky_blue_text"
                            data-bs-target="#ct_edit_user_info"
                            data-bs-toggle="modal"
                            href="javascript:void(0)"
                            >Edit Content</a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item ct_yellow_text"
                            href="javascript:void(0)"
                            data-bs-target="#ct_reactivate_account"
                            data-bs-toggle="modal"
                            >Approve
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item ct_darkblue_text"
                            href="javascript:void(0)"
                            data-bs-target="#ct_suspend_account"
                            data-bs-toggle="modal"
                            >Reject
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item text-danger"
                            href="javascript:void(0)"
                            data-bs-target="#ct_remove_user"
                            data-bs-toggle="modal"
                            >Delete
                          </a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
                  <tr>
                  <td>
                    <h5 class="ct_fs_16  ct_darkblue_text mb-0 ct_overlay_text">“Designing for Mobile”</h5>
                  </td>
                  <td>Coach Talk</td>
                  <td>
                    <span class="ct_publish_badge">Publish</span>
                  </td>
                  <td>May 2, 2025</td>
                
                  <td>
                    <div class="ct_right_dropdown dropdown">
                      <button
                        id="dropdownMenuButton"
                 
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i class="fa-solid fa-ellipsis"></i>
                      </button>
                      <ul
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            data-bs-target="#ct_profile_modal"
                            data-bs-toggle="modal"
                            >View</a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item ct_darksky_blue_text"
                            data-bs-target="#ct_edit_user_info"
                            data-bs-toggle="modal"
                            href="javascript:void(0)"
                            >Edit Content</a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item ct_yellow_text"
                            href="javascript:void(0)"
                            data-bs-target="#ct_reactivate_account"
                            data-bs-toggle="modal"
                            >Approve
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item ct_darkblue_text"
                            href="javascript:void(0)"
                            data-bs-target="#ct_suspend_account"
                            data-bs-toggle="modal"
                            >Reject
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item text-danger"
                            href="javascript:void(0)"
                            data-bs-target="#ct_remove_user"
                            data-bs-toggle="modal"
                            >Delete
                          </a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              
             
            
              </tbody>
            </table>          
            </div>
          </div>
                 
                   
               </div>
               <div className="col-xxl-3 col-xl-4 col-lg-4 mb-4">
                  <div>
               
                <div className="">
                    <div className="ct_outline_bg h-100 ct_py_20_px_10 ct_border_radius_10 ct_box_shadow_card_1">Calander</div>
                  <div className="ct_outline_bg h-100 ct_py_20_px_10 ct_border_radius_10 ct_box_shadow_card_1 ct_mt_30">
                   <div>
                     <p className="ct_fs_20 mb-1 ct_darkblue_text">
                      Upcoming task 
                    </p>
                    <p className="mb-0 ct_fs_14 ct_grey_text">Friday, 24 July 2025</p>
                   </div>
                    <ul className="ct_mt_20">
                      <li>
                        <div class="course-card ct_border_radius_10">
                          <div>
                            <h6 class="ct_fs_16 ct_mb_16 ct_orange_text">Cross Group </h6>
                            <p className="ct_fs_14 ct_grey_text mb-0">09:00 AM - 11:30 AM</p>
                         
                          </div>

                          <div class="progress-circle progress-circle_orange">
                            <span>75%</span>
                          </div>
                        </div>
                      </li>
                      <li className="mt-3">
                        <div
                          class="course-card ct_border_radius_10"
                          style={{
                            backgroundColor: "hsl(199deg 64% 73% / 5%)",
                          }}
                        >
                         <div>
                            <h6 class="ct_fs_16 ct_mb_16 ct_sky_blue_text">Coach Talks</h6>
                            <p className="ct_fs_14 ct_grey_text mb-0">12:00PM - 2:00 PM</p>
                         
                          </div>

                          <div class="progress-circle progress-circle_lightsky">
                            <span>75%</span>
                          </div>
                        </div>
                      </li>
                      <li className="mt-3">
                        <div class="course-card ct_border_radius_10">
                           <div>
                            <h6 class="ct_fs_16 ct_mb_16 ct_yellow_text">Learning</h6>
                            <p className="ct_fs_14 ct_grey_text mb-0">Mini-masterclass </p>
                         
                          </div>

                          <div class="progress-circle progress-circle_yellow">
                            <span>75%</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                    <div className="ct_outline_bg h-100 ct_py_20_px_10 ct_border_radius_10 ct_box_shadow_card_1 ct_mt_30">
                         <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_30">
                            <h5 className="ct_fs_20 ct_darkblue_text mb-0">Messages</h5>
                            <a className="ct_dark_blue_link ct_fs_16">View All</a>
                        </div>

                          <div class="chat-list ct_chatt_list_right_sidear_scroll ct_custom_scroll">
                        <a href="javascript:void(0)" class="d-flex">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4 text-truncate" style={{width:"150px"}}>
                                   So, You need to rewatch lessons?
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4 ct_white_nowrap">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </a>
                       <a href="javascript:void(0)" class="d-flex">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4 text-truncate" style={{width:"150px"}}>
                                   So, You need to rewatch lessons?
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4 ct_white_nowrap">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </a>
                        <a href="javascript:void(0)" class="d-flex">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4 text-truncate" style={{width:"150px"}}>
                                   So, You need to rewatch lessons?
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4 ct_white_nowrap">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </a>
                        <a href="javascript:void(0)" class="d-flex">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4 text-truncate" style={{width:"150px"}}>
                                   So, You need to rewatch lessons?
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4 ct_white_nowrap">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </a>
                        <a href="javascript:void(0)" class="d-flex">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4 text-truncate" style={{width:"150px"}}>
                                   So, You need to rewatch lessons?
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4 ct_white_nowrap">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </a>
                        <a href="javascript:void(0)" class="d-flex">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4 text-truncate" style={{width:"150px"}}>
                                   So, You need to rewatch lessons?
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4 ct_white_nowrap">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </a>
                        <a href="javascript:void(0)" class="d-flex">
                          <div class="ct_chat_list_grid">
                            <div class="position-relative">
                              <img
                                class="img-fluid ct_img_40"
                                src="../assets/img/chat_user.png"
                                alt="user img"
                              />
                            </div>
                            <div class="flex-grow-1 ms-3">
                              <div class="d-flex align-items-center gap-2 justify-content-between">
                                <div>
                                  <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                    Evelyn Shu
                                  </h3>
                                  <p className="ct_fs_12 ct_text_clr_9A96A4 text-truncate" style={{width:"150px"}}>
                                   So, You need to rewatch lessons?
                                  </p>
                                </div>
                                <div className="text-center ms-auto">
                                  <p className="mb-0 ct_text_clr_9A96A4 ct_white_nowrap">
                                    23min
                                  </p>
                                  <div class="ct_caht_msg_notify mt-1  ">
                                    <span class="mx-auto">1</span>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </a>
                      </div>
                                         
                    </div>
                </div>
              </div>
               </div>
            </div>
         </div>
      </div>
         </AdminLayout>
    </div>
  )
}

export default Community